import { IncidentsSideMenuWebComponent } from './component/IncidentsSideMenuWebComponent';
import { WEB_COMPONENT_INCIDENTS_SIDE_MENU } from '../../webcomponents.constants';

export { IncidentsSideMenuWebComponent };

window.customElements.define(WEB_COMPONENT_INCIDENTS_SIDE_MENU, IncidentsSideMenuWebComponent);
